import React from 'react'
import Button from './Button'
import Bar from './Bar'

var style={
    backgroundColor: "#ee5522",
    backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cdefs%3E%3CradialGradient id='a' gradientUnits='objectBoundingBox'%3E%3Cstop offset='0' stop-color='%23FB3'/%3E%3Cstop offset='1' stop-color='%23ee5522'/%3E%3C/radialGradient%3E%3ClinearGradient id='b' gradientUnits='userSpaceOnUse' x1='0' y1='750' x2='1550' y2='750'%3E%3Cstop offset='0' stop-color='%23f7882b'/%3E%3Cstop offset='1' stop-color='%23ee5522'/%3E%3C/linearGradient%3E%3Cpath id='s' fill='url(%23b)' d='M1549.2 51.6c-5.4 99.1-20.2 197.6-44.2 293.6c-24.1 96-57.4 189.4-99.3 278.6c-41.9 89.2-92.4 174.1-150.3 253.3c-58 79.2-123.4 152.6-195.1 219c-71.7 66.4-149.6 125.8-232.2 177.2c-82.7 51.4-170.1 94.7-260.7 129.1c-90.6 34.4-184.4 60-279.5 76.3C192.6 1495 96.1 1502 0 1500c96.1-2.1 191.8-13.3 285.4-33.6c93.6-20.2 185-49.5 272.5-87.2c87.6-37.7 171.3-83.8 249.6-137.3c78.4-53.5 151.5-114.5 217.9-181.7c66.5-67.2 126.4-140.7 178.6-218.9c52.3-78.3 96.9-161.4 133-247.9c36.1-86.5 63.8-176.2 82.6-267.6c18.8-91.4 28.6-184.4 29.6-277.4c0.3-27.6 23.2-48.7 50.8-48.4s49.5 21.8 49.2 49.5c0 0.7 0 1.3-0.1 2L1549.2 51.6z'/%3E%3Cg id='g'%3E%3Cuse href='%23s' transform='scale(0.12) rotate(60)'/%3E%3Cuse href='%23s' transform='scale(0.2) rotate(10)'/%3E%3Cuse href='%23s' transform='scale(0.25) rotate(40)'/%3E%3Cuse href='%23s' transform='scale(0.3) rotate(-20)'/%3E%3Cuse href='%23s' transform='scale(0.4) rotate(-30)'/%3E%3Cuse href='%23s' transform='scale(0.5) rotate(20)'/%3E%3Cuse href='%23s' transform='scale(0.6) rotate(60)'/%3E%3Cuse href='%23s' transform='scale(0.7) rotate(10)'/%3E%3Cuse href='%23s' transform='scale(0.835) rotate(-40)'/%3E%3Cuse href='%23s' transform='scale(0.9) rotate(40)'/%3E%3Cuse href='%23s' transform='scale(1.05) rotate(25)'/%3E%3Cuse href='%23s' transform='scale(1.2) rotate(8)'/%3E%3Cuse href='%23s' transform='scale(1.333) rotate(-60)'/%3E%3Cuse href='%23s' transform='scale(1.45) rotate(-30)'/%3E%3Cuse href='%23s' transform='scale(1.6) rotate(10)'/%3E%3C/g%3E%3C/defs%3E%3Cg transform='rotate(0 0 0)'%3E%3Cg transform='rotate(0 0 0)'%3E%3Ccircle fill='url(%23a)' r='3000'/%3E%3Cg opacity='0.5'%3E%3Ccircle fill='url(%23a)' r='2000'/%3E%3Ccircle fill='url(%23a)' r='1800'/%3E%3Ccircle fill='url(%23a)' r='1700'/%3E%3Ccircle fill='url(%23a)' r='1651'/%3E%3Ccircle fill='url(%23a)' r='1450'/%3E%3Ccircle fill='url(%23a)' r='1250'/%3E%3Ccircle fill='url(%23a)' r='1175'/%3E%3Ccircle fill='url(%23a)' r='900'/%3E%3Ccircle fill='url(%23a)' r='750'/%3E%3Ccircle fill='url(%23a)' r='500'/%3E%3Ccircle fill='url(%23a)' r='380'/%3E%3Ccircle fill='url(%23a)' r='250'/%3E%3C/g%3E%3Cg transform='rotate(0 0 0)'%3E%3Cuse href='%23g' transform='rotate(10)'/%3E%3Cuse href='%23g' transform='rotate(120)'/%3E%3Cuse href='%23g' transform='rotate(240)'/%3E%3C/g%3E%3Ccircle fill-opacity='0.1' fill='url(%23a)' r='3000'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E")`,
    backgroundAttachment: "fixed",
    backgroundSize:"cover"
}

class MergeSort extends React.Component{
    state = {
    numbers: [12, 7, 15, 3, 17, 29, 22,8,5,4,12,1,31,7,10,2],steps:[]
  };
  
  componentDidMount(){
    var {numbers} = this.state;

    this.mergeSort(numbers,0,numbers.length-1);
    var currentSubarray = 0;

    var {s,e} = this.state.steps[currentSubarray]
    var temp = (s === e) ? [numbers[s]] : (numbers[s] < numbers[e] ? [numbers[s],numbers[e]] : [numbers[e],numbers[s]]);
    var idx = s;var tempIdx = 0;
    this.setState({temp,currentSubarray,idx,tempIdx})
  }
  
  startSort = () => {
    if(this.intervalId){
      return;
    }
    this.intervalId = setInterval(() => this.merge(this.state),300);
  }
  
  merge = ({numbers,currentSubarray,idx,tempIdx}) => {
      if(currentSubarray === this.state.steps.length){
        clearInterval(this.intervalId);
        return;
      }
      var temp = this.state.temp
      if(tempIdx < temp.length){
          numbers[idx] = temp[tempIdx];
          idx++;tempIdx++;
          this.setState({numbers,idx,tempIdx})
      
          if(tempIdx === temp.length){
            currentSubarray++;
            if(currentSubarray === this.state.steps.length){
              clearInterval(this.intervalId);
              return;
            }
            temp = [];tempIdx = 0;
            var {s,e} = this.state.steps[currentSubarray]
            var m = Math.floor((s+e)/2);
            idx = s;
            var i = s;var j = m+1;
            while(i <= m && j <= e){
              if(numbers[i] < numbers[j]){
                  temp.push(numbers[i]);
                  i++;continue;            
              }
              temp.push(numbers[j]);j++;
            }
            while(i<=m){
                temp.push(numbers[i]);
                i++;
            }
            while(j<=e){
                temp.push(numbers[j]);
                j++;
            }
            this.setState({currentSubarray,idx,tempIdx,temp})
          }
      }
  }
  mergeSort = (numbers,s,e) => {
    var {steps} = this.state
    if(s>=e){ 
      steps.push({s,e})
      this.setState({steps});
      return;
    }
    let m = Math.floor((s+e)/2)
    this.mergeSort(numbers,s,m)
    this.mergeSort(numbers,m+1,e)
    steps.push({s,e})
    this.setState({steps});
  }

  render() {
    var jsx = this.state.numbers.map((n, i) => {
      var backgroundColor = this.state.idx === i ? "#b54a3a":"#499bd1";
      var border= "solid 2px #d1d1d1";
      var customStyle = {backgroundColor,border};
      return (<Bar key={i} customStyle={customStyle} n={n} />);
    });
    return (
        <div className='main-div' style={style}>
            <div className='bars-container'>
                {jsx}
            </div>
            <Button startSort={this.startSort} title={'Merge Sort'}/>
        </div>
    );
  }
}

export default MergeSort